import React from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../components/ui/Tabs';
import CourseCard from './components/CourseCard';
import LearningStats from './components/LearningStats';

const MyLearning = () => {
  const courses = [
    {
      id: 1,
      title: 'Advanced Mathematics',
      image: 'https://images.unsplash.com/photo-1596495578065-6e0763fa1178?ixlib=rb-1.2.1&auto=format&fit=crop&w=400&q=80',
      duration: '24h',
      lessons: 12,
      progress: 75
    },
    // Add more courses
  ];

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <h1 className="text-3xl font-bold mb-8">My Learning</h1>
      
      <LearningStats />
      
      <div className="mt-12">
        <Tabs defaultValue="in-progress">
          <TabsList>
            <TabsTrigger value="in-progress">In Progress</TabsTrigger>
            <TabsTrigger value="completed">Completed</TabsTrigger>
            <TabsTrigger value="bookmarked">Bookmarked</TabsTrigger>
          </TabsList>
          
          <TabsContent value="in-progress">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mt-6">
              {courses.map(course => (
                <CourseCard key={course.id} course={course} />
              ))}
            </div>
          </TabsContent>
          
          {/* Add content for other tabs */}
        </Tabs>
      </div>
    </div>
  );
};

export default MyLearning;